import { Dialog, Transition } from "@headlessui/react";
import { Fragment } from "react";

interface Props {
  open: boolean;
  onClose: () => void;
  image: string;
}

const HomePromoModal = ({ open, onClose, image }: Props) => {
  return (
    <Transition appear show={open} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={onClose} aria-label="Gana un boleto doble internacional con SKY">
        {/* Overlay */}
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div
            className="fixed inset-0 bg-black/85"
            aria-hidden="true"
          />
        </Transition.Child>

        {/* Contenido */}
        <div className="fixed inset-0 flex items-center justify-center p-4">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <Dialog.Panel className="relative">
              {/* Botón cerrar */}
             <button
                onClick={onClose}
                className="absolute top-2 right-2 text-white text-2xl"
                >✕
            </button>

              {/* Imagen */}
              <img
                src={image}
                alt="Promoción"
                className="max-h-[90vh] max-w-[90vw] rounded-xl"
              />
            </Dialog.Panel>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  );
};

export default HomePromoModal;
